<div [ngClass]="styleClass">
    <span *ngIf="!loading">{{ itemsCount }}</span>
    <span
        style="color: white; font-size: 15px"
        *ngIf="loading"
        class="ci ci-loader"></span>
</div>
